import { Hero } from './Hero';
export { homeHandle as handle } from '../../routeMetadata';
import { ReliefSection } from './ReliefSection';
import { HowItWorks } from './HowItWorks';
import { AvailableBidets } from './AvailableBidets';

export default function Home() {

  return (
    <main className="flex-1">
      <Hero />
      <ReliefSection />
      <HowItWorks />
      <AvailableBidets />
    </main>
  );
}
